import { render, staticRenderFns } from "./VcitaCheckbox.vue?vue&type=template&id=385f3b47&scoped=true"
import script from "./VcitaCheckbox.vue?vue&type=script&lang=js"
export * from "./VcitaCheckbox.vue?vue&type=script&lang=js"
import style0 from "./VcitaCheckbox.vue?vue&type=style&index=0&id=385f3b47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385f3b47",
  null
  
)

export default component.exports